module.exports = __webpack_public_path__ + "static/letterBgVideo-0ea890a1ffb957490aadbe952e05a08b.gif";